module.exports = __webpack_public_path__ + "static/media/lileve-logo-gray-sm.13cc642e.png";